import { render, staticRenderFns } from "./otherBidFilesList.vue?vue&type=template&id=1f2be4f3&scoped=true"
import script from "./otherBidFilesList.vue?vue&type=script&lang=js"
export * from "./otherBidFilesList.vue?vue&type=script&lang=js"
import style0 from "./otherBidFilesList.vue?vue&type=style&index=0&id=1f2be4f3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2be4f3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f2be4f3')) {
      api.createRecord('1f2be4f3', component.options)
    } else {
      api.reload('1f2be4f3', component.options)
    }
    module.hot.accept("./otherBidFilesList.vue?vue&type=template&id=1f2be4f3&scoped=true", function () {
      api.rerender('1f2be4f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/credit/report/pdfDataInfo/mainCreditEvaluation/otherBidFilesList.vue"
export default component.exports